/*
  ZR SEASON - shows the block of each seasonal group whose date window covers
  "today" in the shop's time zone.

  Why the browser recomputes what the server already decided: Shopify caches
  storefront HTML, so a page rendered on Oct 31 can still be served on Nov 1.
  The server-side [hidden] state is only a first paint; this file is the truth.

  Contract (gates in 04_Operations/QA Scripts/hp_common.py):
    [data-zr-season-group] holds items [data-zr-season][data-start][data-end]
    [data-fallback]. Dates are inclusive YYYY-MM-DD in America/Los_Angeles.
    data-zr-season-mode="first": only the first matching item is shown
    (announcement, order-by date). "all": every matching item, in DOM order
    (hero slides). No match: the fallback item(s) are shown instead.
    The day is ALWAYS computed in Los Angeles, never in the visitor's zone:
    a shopper in Hanoi at 13:30 on Nov 1 is still on Oct 31 in the shop.
*/
(function () {
  // Each seasonal section includes this file; run the setup once.
  if (window.ZrSeason) { return; }
  var TZ = 'America/Los_Angeles';

  function today() {
    // Keep the zone option LAST: the HP-G1 known-bad deletes this exact text
    // and the object must stay valid JavaScript without it.
    var parts = new Intl.DateTimeFormat('en-US', {
      year: 'numeric', month: '2-digit', day: '2-digit', timeZone: TZ
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day;
  }

  function apply() {
    var d = today();
    var groups = document.querySelectorAll('[data-zr-season-group]');
    Array.prototype.forEach.call(groups, function (g) {
      var items = Array.prototype.slice.call(g.querySelectorAll('[data-zr-season]'));
      var on = items.filter(function (el) {
        return el.getAttribute('data-start') <= d && d <= el.getAttribute('data-end');
      });
      if (!on.length) {
        on = items.filter(function (el) { return el.getAttribute('data-fallback') === 'true'; });
      }
      if (g.getAttribute('data-zr-season-mode') === 'first') { on = on.slice(0, 1); }
      items.forEach(function (el) {
        var show = on.indexOf(el) !== -1;
        if (show) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
      g.setAttribute('data-zr-season-today', d);
      g.dispatchEvent(new CustomEvent('zr-season:applied', { bubbles: true, detail: { today: d } }));
    });
  }

  window.ZrSeason = { apply: apply, today: today };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
